import { useLocation, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { buildBreadcrumbs } from '../../shared/helpers/build-breadcrumbs';
import { FilterBreadcrumb } from '../../shared/ui';

import type { DateRange } from '@/entities/query/index';
import { Button } from '@/shared/components/shadcn/button';
import { DATE_FORMATS } from '@/shared/utils/date/date-formats';
import dayjs from 'dayjs';

interface Props {
  queryName: string;
  profileCount?: number;
  dateRange: DateRange;
}

export function FilteredProfilesHeader({ queryName, profileCount = 0, dateRange }: Props) {
  const router = useRouter();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const handleBack = () => {
    router.history.back();
  };

  const breadcrumbSegments = [
    ...buildBreadcrumbs(queryName, searchParams),
    {
      label: `${dayjs(dateRange.startDate).format(DATE_FORMATS.base)} - ${dayjs(dateRange.endDate).format(DATE_FORMATS.base)}`,
    },
  ];

  return (
    <div className="bg-background flex flex-col px-6">
      <Button className="my-8 w-fit" variant="outline" size="default" onClick={handleBack}>
        <ArrowLeft className="size-4" />
        Back
      </Button>
      <FilterBreadcrumb segments={breadcrumbSegments} />
      <h1 className="mt-3 mb-1 pl-0 text-xl font-semibold">Profiles ({profileCount})</h1>
    </div>
  );
}
